import React, { useEffect } from "react";
import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Form from "../../../Utils/Form/Formik";
import { Update_admin } from "../../../Services/Superadmin/Superadmin";
import { getUserFromToken } from "../../../Utils/TokenVerify";

const UpdateAdmin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { rowData } = location.state;
  const TokenData = getUserFromToken();

  console.log("rowData", rowData)



  const formik = useFormik({
    initialValues: {
      fullName: rowData?.FullName || "",
      username: rowData?.UserName || "",
      email: rowData?.Email || "",
      phone: rowData?.PhoneNo || "",
      password: "",
      confirmPassword: "",
      FixedPerClient: false,
      FundAdd: false,
      EveryTransaction: false,
      AddClientBonus: "",
      FundLessThan100: "",
      FundLessThan500: "",
      FundLessThan1000: "",
      FundGreaterThan1000: "",
      FixedTransactionPercent: "",
      NetTransactionPercent: false,
      NetTransaction: "",
      Edit_balance: "",
      reopenlogs: "",
      deleteLogs: "",
      reopentrade: "",
      reopendeletetrade: "",
      deleteTrade: "",
      Fund_request: "",
      overall_percent: "",

      market: rowData?.market || [],
      research_permission: "",
    },

    validate: (values) => {
      let errors = {};
      if (!values.fullName) {
        errors.fullName = "Please Enter Full Name";
      }
      if (!values.username) {
        errors.username = "Please Enter Username";
      }
      if (!values.email) {
        errors.email = "Please Enter Email Address";
      } else if (!/^\S+@\S+\.\S+$/.test(values.email)) {
        errors.email = "Please enter a valid email address.";
      }
      if (!values.phone) {
        errors.phone = "Please Enter Phone Number";
      }

      return errors;
    },

    onSubmit: async (values, { setSubmitting }) => {
      const data = {
        id: rowData?._id,
        FullName: values.fullName,
        UserName: values.username,
        Email: values.email,
        PhoneNo: values.phone,
        market: values.market,

        FixedPerClient: values.FixedPerClient,
        AddClientBonus: values.FixedPerClient ? values.AddClientBonus : 0,

        FundAdd: values.FundAdd,
        EveryTransaction: values.FundAdd ? values.EveryTransaction : 0,
        FundLessThan100: values.FundAdd ? values.FundLessThan100 : 0,
        FundLessThan500: values.FundAdd ? values.FundLessThan500 : 0,
        FundLessThan1000: values.FundAdd ? values.FundLessThan1000 : 0,
        FundGreaterThan1000: values.FundAdd ? values.FundGreaterThan1000 : 0,

        EveryTransaction: values.EveryTransaction,
        FixedTransactionPercent: values.EveryTransaction
          ? values.FixedTransactionPercent
          : 0,
        NetTransactionPercent: values.NetTransactionPercent,
        NetTransaction: values.NetTransactionPercent
          ? values.NetTransaction
          : 0,
        Edit_balance: values.Edit_balance === true ? 1 : 0,
        reopentrade: values.reopentrade === true ? 1 : 0,
        reopendeletetrade: values.reopendeletetrade === true ? 1 : 0,
        deleteTrade: values.deleteTrade === true ? 1 : 0,
        reopenlogs: values.reopenlogs === true ? 1 : 0,
        deleteLogs: values.deleteLogs === true ? 1 : 0,
        research_permission: values.research_permission === true ? 1 : 0,
        overall_percent: values.overall_percent,

        Fund_request: values.Fund_request === true ? 1 : 0,
      };

      setSubmitting(false);

      try {
        const response = await Update_admin(data);
        if (response.status) {
          Swal.fire({
            title: "Admin Updated!",
            text: "Admin updated successfully",
            icon: "success",
            timer: 1000,
            timerProgressBar: true,
          });
          setTimeout(() => {
            navigate("/superadmin/admin");
          }, 1500);
        } else {
          Swal.fire({
            title: "Error!",
            text: response.message || "Admin update error",
            icon: "error",
            timer: 1500,
            timerProgressBar: true,
          });
        }
      } catch (error) {
        Swal.fire({
          title: "Error!",
          text: "Failed to Update Admin",
          icon: "error",
          timer: 1500,
          timerProgressBar: true,
        });
      }
    },
  });

  useEffect(() => {
    formik.setValues({
      fullName: rowData?.FullName || "",
      username: rowData?.UserName || "",
      email: rowData?.Email || "",
      phone: rowData?.PhoneNo || "",
      ProfitMargin: rowData?.ProfitMargin || 0,
      password: "",
      confirmPassword: "",
      FixedPerClient: rowData?.FixedPerClient || false,
      FundAdd: rowData?.FundAdd || false,
      EveryTransaction: rowData?.EveryTransaction || false,
      AddClientBonus: rowData?.AddClientBonus || "",
      FundLessThan100: rowData?.FundLessThan100 || "",
      FundLessThan500: rowData?.FundLessThan500 || "",
      FundLessThan1000: rowData?.FundLessThan1000 || "",
      FundGreaterThan1000: rowData?.FundGreaterThan1000 || "",
      FixedTransactionPercent: rowData?.FixedTransactionPercent || "",
      NetTransactionPercent: rowData?.NetTransactionPercent || false,
      NetTransaction: rowData?.NetTransaction || "",
      Edit_balance: rowData?.Edit_balance == 1 ? true : false,
      reopentrade: rowData?.reopentrade == 1 ? true : false,
      reopendeletetrade: rowData?.reopendeletetrade == 1 ? true : false,
      deleteTrade: rowData?.deleteTrade == 1 ? true : false,
      reopenlogs: rowData?.reopenlogs == 1 ? true : false,
      deleteLogs: rowData?.deleteLogs == 1 ? true : false,
      research_permission: rowData?.research_permission == 1 ? true : false,
      Fund_request: rowData?.Fund_request == 1 ? true : false,
      overall_percent: rowData?.overall_percent,
      market: rowData?.market || [],
    });
  }, [rowData]);

  // Dependencies between fields
  useEffect(() => {
    if (formik.values.FixedPerClient) {
      formik.setFieldValue("FundAdd", false);
    }
  }, [formik.values.FixedPerClient]);

  useEffect(() => {
    if (formik.values.FundAdd) {
      formik.setFieldValue("FixedPerClient", false);
    }
  }, [formik.values.FundAdd]);

  useEffect(() => {
    if (formik.values.EveryTransaction) {
      formik.setFieldValue("NetTransactionPercent", false);
      formik.setFieldValue("NetTransaction", "");
    }
  }, [formik.values.EveryTransaction]);

  useEffect(() => {
    if (formik.values.NetTransactionPercent) {
      formik.setFieldValue("EveryTransaction", false);
      formik.setFieldValue("FixedTransactionPercent", "");
    }
  }, [formik.values.NetTransactionPercent]);

  const fields = [
    { type: "heading", label: "Basic Details", col_size: 12 },
    { name: "fullName", label: "Full Name", type: "text", label_size: 6, col_size: 6 },
    { name: "username", label: "Username", type: "text", label_size: 12, col_size: 6, disable: true },
    { name: "email", label: "Email", type: "text", label_size: 12, col_size: 6 },
    { name: "phone", label: "Phone Number", type: "text3", label_size: 12, col_size: 6 },
    { name: "ProfitMargin", label: "Brokerage Sharing", type: "text4", label_size: 12, col_size: 6 },
    { name: "overall_percent", label: "Overall Percent", type: "text4", label_size: 12, col_size: 6 },
    {
      col_size: 6,
    },

    { type: "heading", label: "Funding", col_size: 12 },
    { name: "FixedPerClient", label: "Fixed (Per Client)", type: "checkbox", col_size: 6 },
    { name: "FundAdd", label: "First-Time Funding Reward", type: "checkbox", col_size: 6 },
    {
      name: "AddClientBonus", label: "Add Client Bonus", type: "number", col_size: 12,
      showWhen: (values) => formik.values.FixedPerClient,
      disable: formik.values.FixedPerClient,
    },


    { name: "FundLessThan100", label: "Fund < 100", type: "number", col_size: 6, showWhen: (values) => values.FundAdd },
    { name: "FundLessThan500", label: "Fund < 500", type: "number", col_size: 6, showWhen: (values) => values.FundAdd },
    { name: "FundLessThan1000", label: "Fund < 1000", type: "number", col_size: 6, showWhen: (values) => values.FundAdd },
    { name: "FundGreaterThan1000", label: "Fund > 1000", type: "number", col_size: 6, showWhen: (values) => values.FundAdd },

    { name: "EveryTransaction", label: "Every Transaction %", type: "checkbox", col_size: 6 },
    { name: "NetTransactionPercent", label: "Net Transaction %", type: "checkbox", col_size: 6 },
    { name: "FixedTransactionPercent", label: "Fixed Transaction %", type: "text4", col_size: 12, showWhen: (values) => values.EveryTransaction },
    { name: "NetTransaction", label: "Net Transaction %", type: "text4", col_size: 12, showWhen: (values) => values.NetTransactionPercent },

    { name: "Edit_balance", label: "Edit Balance", type: "checkbox", col_size: 6 },
    { name: "Fund_request", label: "Withdrawal/Deposit Request", type: "checkbox", col_size: 6 },
    TokenData?.reopenpermission_trade?.includes(1) && { name: "reopentrade", label: "Reopen Trade", type: "checkbox", col_size: 6 },
    TokenData?.reopenpermission_trade?.includes(1) && { name: "reopenlogs", label: "Reopen Logs", type: "checkbox", col_size: 6 },
    TokenData?.delete_permission_trade?.includes(1) && { name: "reopendeletetrade", label: "Reopen Deleted Trade", type: "checkbox", col_size: 6 },
    TokenData?.delete_permission_trade?.includes(1) && { name: "deleteTrade", label: "DeleteTrade Trade", type: "checkbox", col_size: 6 },
    TokenData?.delete_permission_trade?.includes(1) && { name: "deleteLogs", label: "Delete Logs", type: "checkbox", col_size: 6 },
    // TokenData?.research_permission?.includes(1) && { name: "research_permission", label: "research permission ", type: "checkbox", col_size: 6 },
    (TokenData?.research_permission === undefined ||
      (Array.isArray(TokenData?.research_permission) &&
        TokenData.research_permission.map(Number).includes(1))) && {
      name: "research_permission",
      label: "Research Permission",
      type: "checkbox",
      col_size: 4,
    },
    { type: "heading", label: "Markets", col_size: 12 },
  ].filter(Boolean);

  return (
    <>
      <Form
        fields={fields.filter((item) => (item.showWhen ? item.showWhen(formik.values) : true))}
        page_title="Update Admin"
        btn_name="Update Admin"
        btn_name1="Cancel"
        formik={formik}
        btn_name1_route={"/superadmin/admin"}
        additional_field={
          <div className="col-lg-6 mt-4">
            <label className="fw-bold mb-2">Select Markets</label>
            <div className="d-flex gap-4 align-items-center">

              {TokenData?.market.includes(0) && <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="market-forex"
                  checked={formik.values.market.includes(0)}
                  disabled={rowData?.market?.includes(0)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      formik.setFieldValue("market", [...formik.values.market, 0]);
                    } else {
                      formik.setFieldValue("market", formik.values.market.filter((m) => m !== 0));
                    }
                  }}
                />
                <label className="form-check-label fw-semibold" htmlFor="market-forex">Forex</label>
              </div>}

              {/* India */}
              {TokenData?.market.includes(1) && <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="market-india"
                  checked={formik.values.market.includes(1)}
                  disabled={rowData?.market?.includes(1)} // पहले से selected तो disable
                  onChange={(e) => {
                    if (e.target.checked) {
                      formik.setFieldValue("market", [...formik.values.market, 1]);
                    } else {
                      formik.setFieldValue("market", formik.values.market.filter((m) => m !== 1));
                    }
                  }}
                />
                <label className="form-check-label fw-semibold" htmlFor="market-india">India</label>
              </div>}
            </div>

            {formik.errors.market && (
              <div className="text-danger mt-2 small">{formik.errors.market}</div>
            )}

          </div>
        }
      />


    </>
  );
};

export default UpdateAdmin;
